import React from 'react';
import { StyleSheet, View } from 'react-native';
import Button from 'shared/components/vxl/Button/Button';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import { ListItemGroupItem } from 'shared/components/vxl/ListItemGroup/ListItemGroup';
import BodyXSBoldText from 'shared/components/vxl/typography/primary/body/BodyXSBoldText';
import theme from 'shared/styles/theme';

export interface DiscoverMoreSectionProps {
  title: string;
  items: ListItemGroupItem[];
  viewMoreButton?: {
    label: string;
    onPress: () => void;
  } | null;
}

const DiscoverMoreSection = ({
  title,
  items,
  viewMoreButton,
}: DiscoverMoreSectionProps) => {
  return (
    <View style={styles.container}>
      <BodyXSBoldText numberOfLines={1} style={styles.title}>
        {title}
      </BodyXSBoldText>
      <View style={styles.listContainer}>
        {items.map(({ keyId, ...itemProps }, index) => (
          <React.Fragment key={keyId ?? itemProps.primaryCopy}>
            <ListItem {...itemProps} colorTheme="surface" />
            {index < items.length - 1 ? (
              <View style={styles.divider}>
                <HairLineDivider />
              </View>
            ) : null}
          </React.Fragment>
        ))}
      </View>
      {viewMoreButton ? (
        <View style={styles.buttonContainer}>
          <Button
            label={viewMoreButton.label}
            onPress={viewMoreButton.onPress}
            size="LARGE"
            type="SECONDARY"
            width="FULL"
          />
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing.s,
  },
  title: {
    color: theme.color.text.secondary,
    paddingHorizontal: theme.spacing.m,
    ...theme.typography.title.sm,
  },
  divider: {
    marginHorizontal: theme.spacing.m,
  },
  listContainer: {
    backgroundColor: theme.color.interactive.surface,
  },
  buttonContainer: {
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.s,
  },
});

export default DiscoverMoreSection;
